import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {TaskTypeDialogComponent} from '@common-components/task-type/task-type-dialog/task-type-dialog.component';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {ToastrService} from 'ngx-toastr';
import {ConstantsService} from "@app/services/constants/constants.service";
import {BackendResponse} from "@app/interfaces/backendResponse";


@Component({
    selector: 'app-task-type',
    templateUrl: './task-type.component.html',
    styleUrls: ['./task-type.component.css']
})
export class TaskTypeComponent implements OnInit {
    @Input() data: { name: string, _id: string };

    @Output() output = new EventEmitter<any>();

    userTypes: any[] = [];
    searchText = '';
    buttonText = 'Vrsta zadatka';
    isSelected: boolean;
    addingPermission = false;


    constructor(private dialog: MatDialog,
                private taskSrvc: TaskService,
                private toastrSrvc: ToastrService,
                private constantsService: ConstantsService) {
    }

    async ngOnInit() {
        this.addingPermission = this.constantsService.admins.find(x => x === this.constantsService.getLoggedInUserId()) !== undefined;
        if (this.data) {
            if (this.data.name) {
                this.searchText = this.data.name;
                this.buttonText = this.data.name;
                this.isSelected = true;
            }
        }
        const result = await this.getTypes();

    }

    getType(data) {
        this.output.emit(data);
        this.isSelected = true;
    }

    openDialog() {
        let dialog = this.dialog.open(TaskTypeDialogComponent, {
            hasBackdrop: true
        });

        dialog.afterClosed().subscribe((res) => {
            this.userTypes = res.data;
        })

    }

    async getTypes() {
        this.taskSrvc.getTaskTypes().subscribe((response: BackendResponse) => {
            if (response['type'] === 'success') {
                this.userTypes = response['data'];
            } else {
                this.toastrSrvc.error('Doslo je do greške.');
            }
        });

    }

    clearData() {
        if (this.userTypes.length == 0) {
            this.toastrSrvc.info('Nemate kreirane vrste zadatka. Molimo vas unesite ih klikom na dugme "+".')
        }
        this.isSelected = false;
        this.searchText = '';
        this.buttonText = 'Vrsta zadatka'
        this.output.emit(null);
    }

}
